import axios from 'axios'
import config from '@/config'

export default axios.create({
  baseURL: process.env.NODE_ENV === 'development'
      ? 'http://localhost:3037/api'
      : `${config.baseURL}/api`,
})
